// extracted by mini-css-extract-plugin
export default {"imagesGalleryContainer":"imagesGallery_imagesGalleryContainer__DkHNV"};